<template>
    <div class="file-progress" v-if="downloadPercentage > 0 || uploadPercentage > 0" v-show="!downloading">
        <div v-if="downloadPercentage > 0 && downloadPercentage > 100">
            <div class="bar" :style="{'width': percentage + '%'}">
            </div>
            <span>Protecting: {{percentage}}%</span>
        </div>
        <div v-if="uploadPercentage > 0">
            <div class="bar" :style="{'width': uploadPercentage + '%'}">
            </div>
            <span>Transferring: {{uploadPercentage}}%</span>
        </div>
    </div>
</template>
<script>

import toastr from 'toastr';


export default {
    data() {
        return {
            downloadPercentage: 0,
            uploadPercentage: 0

        }
    },
    components: {

    },
    mounted() {

        this.sockets.subscribe('watermark_progress', ({ total, received }) => {
            this.downloadPercentage = Math.round((received * 100) / total);
            if (this.downloadPercentage >= 100) {
                this.uploadPercentage = 5;                
            }
        });

        this.sockets.subscribe('watermark_finalized', ({ total, done }) => {
            this.uploadPercentage = Math.round((done * 100) / total);
            if (this.uploadPercentage >= 100) {
                this.uploadPercentage = 0;
                this.downloadPercentage = 0;  
                    this.$store.dispatch('populate', {
                    type: 'downloading',
                    data: false
               }); 
            }
        });
    },

    methods: {

    },
    computed: {
        downloading() {
            return this.$store.state.downloading;
        }
    },

}

</script>

<style lang="scss" scoped>
.file-progress {
    background: #333;
    width: 100%;
    height: 4rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
        z-index: 9999999999;
        display: block;
        background: #555;
        color: #Fff;
        padding: .5rem 1rem;
        border-radius: 3px;
        font-weight: 600;
        font-size: 1.6rem;
    }

    .bar {
        height: 100%;
        background: #3df;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999999999;
    }
}

</style>





// WEBPACK FOOTER //
// FileProgress.vue?59282ee2